import React from "react";
import styles from "./About.module.css";

export default function About() {
  return (
    <div className={styles.pageWrapper}>
      {/* ✅ HERO SECTION */}
      <section className={styles.hero}>
        <div className={styles.overlay}></div>
        <div className={styles.heroContent}>
          <h1 className={styles.title}>About BNI Brisk</h1>
          <p className={styles.subtitle}>
            Powered by the leadership of Executive Director Ayushman Aggarwal
          </p>
        </div>
      </section>

      {/* ✅ AYUSHMAN INTRO */}
      <section className={"container " + styles.introSection}>
        <h2 className={styles.sectionTitle}>Meet Ayushman Aggarwal</h2>
        <div className={styles.leaderProfile}>
          <img
            src="/images/AyushmanPic.jpeg"
            alt="Ayushman Aggarwal"
            className={styles.leaderPhoto}
          />
          <div className={styles.leaderBio}>
            <p className={styles.sectionText}>
              <strong>Ayushman Aggarwal</strong> serves as the Executive
              Director of BNI Brisk. With a deep passion for business growth and
              community impact, he has been instrumental in building one of
              Bihar’s most dynamic business referral networks. His leadership
              emphasizes collaboration, education, and empowerment—helping
              members achieve measurable results through meaningful
              relationships.
            </p>
            <p className={styles.sectionText}>
              Under his strategic direction, BNI Brisk continues to set new
              benchmarks in professionalism and member engagement, reflecting
              the core BNI philosophy of <strong>Givers Gain®</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* ✅ ABOUT BNI */}
      <section className={"container " + styles.aboutSection}>
        <h2 className={styles.sectionTitle}>About BNI</h2>
        <p className={styles.sectionText}>
          BNI (Business Network International) is the world’s largest business
          networking and referral organisation, built on the guiding philosophy
          of <strong>Givers Gain®</strong> — the more you give, the more you
          gain.
        </p>
        <p className={styles.sectionText}>
          Since its founding in 1985, BNI has empowered millions of
          entrepreneurs to grow through structured, positive, and supportive
          business networking programs. Every week, members worldwide meet to
          share qualified referrals, foster collaboration, and build trusted
          partnerships.
        </p>
      </section>

      {/* ✅ LEADER INSIGHT — NITESH BIDASARIA (formerly Arun Kumar Jain) */}
      <section className={"container " + styles.leaderSection}>
        <h2 className={styles.sectionTitle}>
          Nitesh Bidasaria — President, BNI Brisk
        </h2>
        <div className={styles.leaderProfile}>
          <img
            src="/images/nitesh.png"
            alt="Nitesh Bidasaria"
            className={styles.leaderPhoto}
          />
          <div className={styles.leaderBio}>
            <p className={styles.sectionText}>
              <strong>Nitesh Bidasaria</strong>, President of BNI Brisk, is the
              driving force behind the chapter’s culture of excellence. With a
              business background in <em>Bidasaria Fenster Solutions</em>—a
              leading name in premium windows and doors—he combines innovation,
              quality, and customer-centric values in every endeavor.
            </p>
            <p className={styles.sectionText}>
              Nitesh embodies the spirit of BNI’s “Givers Gain” philosophy,
              fostering a professional environment where every member supports
              one another’s success. His vision focuses on member engagement,
              structured growth, and measurable outcomes for every business in
              the chapter.
            </p>
          </div>
        </div>
      </section>

      {/* ✅ LEADER INSIGHT — AYUSH MITTAL (formerly Kunal Dalmia) */}
      <section className={"container " + styles.leaderSection}>
        <h2 className={styles.sectionTitle}>
          Ayush Mittal — Vice President, BNI Brisk
        </h2>
        <div className={styles.leaderProfile}>
          <img
            src="/images/ayushMittal.png"
            alt="Ayush Mittal"
            className={styles.leaderPhoto}
          />
          <div className={styles.leaderBio}>
            <p className={styles.sectionText}>
              <strong>Ayush Mittal</strong>, Vice President of BNI Brisk and
              owner of <em>Bikaner Elite</em>, represents a perfect blend of
              entrepreneurial energy and community leadership. As a successful
              business leader in the sweets manufacturing and retail sector, his
              professional journey is rooted in consistency, innovation, and
              trust.
            </p>
            <p className={styles.sectionText}>
              Ayush is known for his dedication to system-driven growth and his
              active mentorship of members across the region. His insights on
              teamwork, goal setting, and member engagement have helped elevate
              BNI Brisk’s reputation as a high-performing and cohesive chapter.
            </p>
          </div>
        </div>
      </section>

      {/* ✅ WHY JOIN */}
      <section className={"container " + styles.joinSection}>
        <h2 className={styles.sectionTitle}>Why Join BNI Brisk?</h2>
        <p className={styles.sectionText}>
          Under the strategic leadership of Ayushman Aggarwal, our chapter
          brings you:
        </p>
        <ul className={styles.benefitsList}>
          <li>
            Exclusive access to a trusted network of business professionals
          </li>
          <li>A structured referral-generation system that works</li>
          <li>
            Regular training and one-on-one mentoring to sharpen your business
            edge
          </li>
          <li>
            The opportunity to plug into global referrals while staying locally
            connected
          </li>
        </ul>
      </section>
    </div>
  );
}
